import { render, staticRenderFns } from "./MobileFooter.vue?vue&type=template&id=3a0022c9&scoped=true"
import script from "./MobileFooter.vue?vue&type=script&lang=js"
export * from "./MobileFooter.vue?vue&type=script&lang=js"
import style0 from "./MobileFooter.vue?vue&type=style&index=0&id=3a0022c9&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0022c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a0022c9')) {
      api.createRecord('3a0022c9', component.options)
    } else {
      api.reload('3a0022c9', component.options)
    }
    module.hot.accept("./MobileFooter.vue?vue&type=template&id=3a0022c9&scoped=true", function () {
      api.rerender('3a0022c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/homePage/mobile/MobileFooter.vue"
export default component.exports